import { Befehl } from '../models'
import { hasBefehl1EmptyFields } from './befehl-1'
import { hasBefehl2EmptyFields } from './befehl-2'
import { hasBefehl3EmptyFields } from './befehl-3'
import { hasBefehl4EmptyFields } from './befehl-4'
import { hasBefehl5EmptyFields } from './befehl-5'
import { hasBefehl6EmptyFields } from './befehl-6'
import { hasBefehl7EmptyFields } from './befehl-7'
import { hasBefehl8EmptyFields } from './befehl-8'
import { hasBefehl9EmptyFields } from './befehl-9'
import { hasBefehl22EmptyFields } from './befehl-22'
import { hasBefehl23EmptyFields } from './befehl-23'
import { hasBefehl24EmptyFields } from './befehl-24'
import { hasBefehl26EmptyFields } from './befehl-26'
import { hasBefehl27EmptyFields } from './befehl-27'
import { hasBefehl28EmptyFields } from './befehl-28'
import { hasBefehl29EmptyFields } from './befehl-29'
import { hasBefehl31EmptyFields } from './befehl-31'
import { hasBefehl34EmptyFields } from './befehl-34'
import { hasBefehl95EmptyFields } from './befehl-95'

import { hasBefehlGenericEmptyFields } from './generic'
import { hasBefehl21EmptyFields } from './befehl-21'
import { hasBefehl33EmptyFields } from './befehl-33'
import { hasBefehl25EmptyFields } from './befehl-25'

/**
 * Checks if a befehl has empty fields.
 * Dispatches to the appropriate checker based on befehl type.
 *
 * @returns true if has empty fields, false otherwise
 */
export function hasBefehlEmptyFields(
  befehl: Befehl | null | undefined
): boolean {
  if (!befehl) return false

  switch (befehl.kennung) {
    case '1':
      return hasBefehl1EmptyFields(befehl)
    case '2':
      return hasBefehl2EmptyFields(befehl)
    case '3':
      return hasBefehl3EmptyFields(befehl)
    case '4':
      return hasBefehl4EmptyFields(befehl)
    case '5':
      return hasBefehl5EmptyFields(befehl)
    case '6':
      return hasBefehl6EmptyFields(befehl)
    case '7':
      return hasBefehl7EmptyFields(befehl)
    case '8':
      return hasBefehl8EmptyFields(befehl)
    case '9':
      return hasBefehl9EmptyFields(befehl)
    case '21':
      return hasBefehl21EmptyFields(befehl)
    case '22':
      return hasBefehl22EmptyFields(befehl)
    case '23':
      return hasBefehl23EmptyFields(befehl)
    case '24':
      return hasBefehl24EmptyFields(befehl)
    case '25':
      return hasBefehl25EmptyFields(befehl)
    case '26':
      return hasBefehl26EmptyFields(befehl)
    case '27':
      return hasBefehl27EmptyFields(befehl)
    case '28':
      return hasBefehl28EmptyFields(befehl)
    case '29':
      return hasBefehl29EmptyFields(befehl)
    case '31':
      return hasBefehl31EmptyFields(befehl)
    case '33':
      return hasBefehl33EmptyFields(befehl)
    case '34':
      return hasBefehl34EmptyFields(befehl)
    case '95':
      return hasBefehl95EmptyFields(befehl)
    default:
      return hasBefehlGenericEmptyFields(befehl)
  }
}

/**
 * Hook-like function for empty field checking with warnings toggle.
 */
export function useEmptyFieldsCheck(
  befehl: Befehl | null | undefined,
  activateWarnings: boolean
): boolean {
  if (!activateWarnings) return false
  return hasBefehlEmptyFields(befehl)
}
